import HeadingBlockEditor from "./HeadingBlockEditor";
import TextBlockEditor from "./TextBlockEditor";
import ImageBlockEditor from "./ImageBlockEditor";
import CodeBlockEditor from "./CodeBlockEditor";
import ListBlockEditor from "./ListBlockEditor";
import InfoBlockEditor from "./InfoBlockEditor";
import WarningBlockEditor from "./WarningBlockEditor";

export default function BlockRenderer({ block, onUpdate }) {

    switch (block.type) {

        case "heading":
            return <HeadingBlockEditor block={block} onChange={onUpdate} />;

        case "text":
            return <TextBlockEditor block={block} onChange={onUpdate} />;

        case "image":
            return <ImageBlockEditor block={block} onChange={onUpdate} />;

        case "code":
            return <CodeBlockEditor block={block} onChange={onUpdate} />;

        case "list":
            return <ListBlockEditor block={block} onChange={onUpdate} />;

        case "info":
            return <InfoBlockEditor block={block} onChange={onUpdate} />;

        case "warning":
            return <WarningBlockEditor block={block} onChange={onUpdate} />;

        default:
            return null;
    }

}